module.exports = __webpack_public_path__ + "media/faqSection/faq-16d914e8.jpg";